"use client";

import { IconChatBubbleOutline18 } from "nucleo-ui-outline-18";
import { useEffect, useMemo, useState } from "react";
import { generateSampleFromSchema } from "../sampleGenerators";
import type { TriggerArchetypeProps } from "./types";
const PLATFORM_LABELS: Record<string, string> = {
  "telegram-channel": "Telegram",
  "slack-new-direct-message": "Slack",
  "slack-new-message-in-channels": "Slack",
  "slack-new-keyword-mention": "Slack"
};

/**
 * ChatBotGuide archetype — lets the user type a sample message to test with.
 *
 * Generates a full payload matching the trigger's result schema, with the
 * user's typed message as the `text` field.
 */
export function ChatBotGuide({
  triggerType,
  triggerPayload,
  resultSchema,
  onRun
}: TriggerArchetypeProps) {
  const platform = PLATFORM_LABELS[triggerType] ?? "Bot";
  const [message, setMessage] = useState("hello");

  // Generate full sample payload from schema, then override text with user input
  const sampleBase = useMemo(() => generateSampleFromSchema(resultSchema, triggerType, triggerPayload), [resultSchema, triggerType, triggerPayload]);

  // Notify parent of current payload
  useEffect(() => {
    onRun({
      ...sampleBase,
      text: message,
      triggeredAt: new Date().toISOString()
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- onRun is a stable state setter
  }, [message, sampleBase]);
  return <div className="space-y-3">
      <div className="label label-xs flex items-center gap-2">
        <span>Type a sample {platform} message to test with</span>
        <IconChatBubbleOutline18 className="text-ds-text-disabled h-4 w-4" />
      </div>
      <textarea value={message} onChange={e => setMessage(e.target.value)} rows={2} placeholder={`Type a ${platform} message...`} className="border-ds-border-default text-ds-text-primary placeholder:text-ds-text-disabled bg-ds-surface-card w-full rounded-lg border px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20" />
    </div>;
}